import React from 'react'
import 'regenerator-runtime/runtime'
import MyRooms from '../routes/MyDecor'

const Routes = () => {
  return <MyRooms />
}

export default Routes
